import { EMPTY_FIELD } from 'constants/emptyField';

import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { PresetItem } from 'types/embedded/preset';
import { formatCurrency } from 'utils';

export const PresetsShowGridCard: React.FC<{ item: PresetItem }> = ({ item }) => (
  <CardTable tableBodyProps={{ sx: { '& td': { width: '122px' } } }}>
    <TableRowWrapper label="Направление">{item.direction.description}</TableRowWrapper>
    <TableRowWrapper label="Сумма">{formatCurrency(Number(item.amount))}</TableRowWrapper>
    <TableRowWrapper label="Бейдж">{item.badge?.description || EMPTY_FIELD}</TableRowWrapper>
    <TableRowWrapper label="Описание">{item.description || EMPTY_FIELD}</TableRowWrapper>
  </CardTable>
);
